import { hidePaymentGatewayError, pageRequest } from 'actions/outletPages/list'
import ActionBar from './ActionBar'
import Table from './Table'
import OutletDetail from './OutletDetail'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { askConfirmAction } from 'actions/confirm-action'
import { push } from 'react-router-redux'
import { getFormValues, isDirty } from 'redux-form'
import ConfirmActionModal from 'components/ConfirmActionModal'
import ReactivateOutletModal from './ConfirmReactivateOutletModal'
import AddOutletModal from './AddOutletModal'
import { ContentWrapper, LeftColumnWrapper, PageWrapper, RightColumnWrapper } from 'components/wrappers/pages'
import NoDataAndLoading from 'components/NoDataAndLoading'
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal'
import ReactiveOutletWithoutPayModal from './ReactiveOutletWithoutPayModal'

class List extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const {billingNotification} = this.props
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      this.props.dispatch(pageRequest(billingNotification))
      browserHistory.listenBefore((location) => {
        if (this.props.data.isDirtyForm && this.props.data.confirmAction.nextAction === null) {
          // negate the change location, instead use sagas to handle the change location
          this.props.dispatch(askConfirmAction(push(location.pathname)))
          return false
        }
      })
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {outlets, outletDetail, openRightColumn} = this.props.data.outletPages.list
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    let {outletCount, outletPrice, showPaymentGatewayErrorModal} = this.props.data

    return (
      <PageWrapper>
        <ActionBar dispatch={this.props.dispatch} />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={outlets.length === 0}
              title='No Data To Display'
              description='' />
            <Table
              outlets={outlets}
              dispatch={this.props.dispatch}
              outletDetail={outletDetail}
              isDirtyForm={this.props.data.isDirtyForm}
            />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <OutletDetail
              outlet={outletDetail}
              dispatch={this.props.dispatch}
              outlets={outlets}
            />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <ReactivateOutletModal />
        <ReactiveOutletWithoutPayModal />
        <AddOutletModal />
        {
          outletPrice && outletCount &&
          <PaymentGatewayErrorModal
            totalPrice={(outletPrice['final_price'] * parseInt(outletCount.countOutlet)).toString()}
            showModal={showPaymentGatewayErrorModal} onHide={() => { this._onHideModal() }} />
        }
      </PageWrapper>
    )
  }

  _onHideModal = () => {
    this.props.dispatch(hidePaymentGatewayError())
  }
}

List.propTypes = {
  dispatch: React.PropTypes.func
}

function mapStateToProps (state) {
  const {outletPrice, showPaymentGatewayErrorModal} = state.outletPages.list
  const {billingNotification} = state
  return {
    data: {
      isDirtyForm: isDirty('outlet')(state),
      confirmAction: state.confirmAction,
      outletPages: {
        list: state.outletPages.list
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired,
      outletCount: getFormValues('AddOutletModalForm')(state),
      outletPrice,
      showPaymentGatewayErrorModal
    },
    billingNotification
  }
}

export default connect(mapStateToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Outlets/List/List.js